/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular'
import { PidxPdsModalWrapperComponent } from './pidx-pds-modal-wrapper.component'

@NgModule({
  imports: [CommonModule, PorscheDesignSystemModule],
  declarations: [PidxPdsModalWrapperComponent],
  exports: [PidxPdsModalWrapperComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PidxPdsModalWrapperModule {}
